import * as React from 'react';
import {Box, IconButton, List, ListItem, ListItemText, Popper as MuiPopper, Typography} from "@material-ui/core";
import {FC} from "react";
import FilterListIcon from '@mui/icons-material/FilterList';
import styled from "styled-components/macro";
import {ListItemButton} from "@mui/material";

const Popper = styled(MuiPopper)`
  background: #233044;
  border-radius: 4px;
  border: 1px solid #56606f;
  .MuiListItem-root {
    padding: 0
  }
`

type PropsType = {
    title: string;
    selected?: any
    list: {name: string, value: string | boolean | number}[]
    onClick?: (value: string | boolean | number) => void
}

const FilterButton: FC<PropsType> = ({title, list, onClick, selected}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <Box>
            {title}{selected ? ` (${selected})` : ''}
            <IconButton aria-describedby={id} type="button" onClick={handleClick} size={'small'} style={{marginLeft: 5}}>
                <FilterListIcon/>
            </IconButton>
            <Popper id={id} open={open} anchorEl={anchorEl}>
                <List disablePadding>
                    {list.map((i) => (
                        <ListItem disableGutters selected={selected === i.value}>
                            <ListItemButton onClick={() => {
                                onClick && onClick(i.value)
                                setAnchorEl(null)
                            }}>
                                <ListItemText primary={i.name} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Popper>
        </Box>
    );
}

export default FilterButton